import { request, downloadFile } from './client';

export const apiCreateOrder = (orderData) =>
  request('/orders', { method: 'POST', body: orderData });

export const apiGetPaymentConfig = () => request('/orders/payment-config');

export const apiCreateRazorpayOrder = (orderData) =>
  request('/orders/razorpay', { method: 'POST', body: orderData });

export const apiVerifyRazorpayPayment = (payload) =>
  request('/orders/razorpay/verify', { method: 'POST', body: payload });

export const apiCreatePayPalOrder = (orderData) =>
  request('/orders/paypal/create', { method: 'POST', body: orderData });

export const apiCapturePayPalPayment = (payload) =>
  request('/orders/paypal/capture', { method: 'POST', body: payload });

export const apiRetryRazorpayPayment = (orderId) =>
  request(`/orders/${orderId}/retry-payment`, { method: 'POST' });

export const apiRetryPayPalPayment = (orderId) =>
  request(`/orders/${orderId}/retry-paypal`, { method: 'POST' });

export const apiGetOrders = () => request('/orders');

export const apiGetOrderById = (orderId) => request(`/orders/${orderId}`);

export const apiCancelOrder = (orderId) =>
  request(`/orders/${orderId}/cancel`, { method: 'PUT' });

export const apiDownloadInvoice = (orderId) =>
  downloadFile(`/orders/${orderId}/invoice`, `invoice-${orderId}.pdf`);
